import {ICON_BUTTON_CONTROL_ACTIONS} from '../../controls/icon-button-control/icon-button-control.types';
import {makeIconButtonControl} from '../../controls/icon-button-control/icon-button-control';
import {isMultiselectComponent, registerEmailMakerSector} from '../../right-panel-registry';
import {deleteControl, duplicateControl} from '../shared/common-action-controls';

const clearSelectionControl = makeIconButtonControl({
  action: ICON_BUTTON_CONTROL_ACTIONS.CLEAR_SELECTION,
  labelKey: 'pmwjs_clear_selection',
  iconClass: 'icon-close',
});

/** Must be registered first so multiselect is checked before any exact-type branch. */
registerEmailMakerSector((component, editor) => isMultiselectComponent(component, editor), {
  title: window.i18next.t('pmwjs_group'),
  properties: [{control: duplicateControl}, {control: deleteControl}, {control: clearSelectionControl}],
});
